import { Text, TextMessage } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import React from 'react';

class NoiDungKienNghiDoiTuongThanhTra extends React.Component {

  render() {
    let CountCaNhanCoSaiPham = 0;
    let CountToChucCoSaiPham = 0;
    if (this.props.toChucCoSaiPham) {
      CountToChucCoSaiPham = this.props.toChucCoSaiPham.split('; ').length
    }
    if (this.props.caNhanCoSaiPham) {
      CountCaNhanCoSaiPham = this.props.caNhanCoSaiPham.split('; ').length
    }
    return (
      <div className='wrap-items-content'>
        <div className='col-100 no-gutter'>
          <h2 className='title-12 col-100 mb10'>1.1. Kiến nghị thu hồi</h2>
          <div className='col-50 no-gutter'>
            <h2 className='txt-bold txt-upper col-100 mb10'>Thu hồi về NSNN</h2>
            <Text className='col-50 mb10' label='Về tiền (đ):' value={this.props.tienDaThuHoiVeNganSachNhaNuoc} />
            <Text className='col-50 mb10' label='Về đất (m2):' value={this.props.datDaThuHoiVeNganSachNhaNuoc} />
          </div>
          <div className='col-50 no-gutter'>
            <h2 className='txt-bold txt-upper col-100 mb10'>Thu hồi về tổ chức, đơn vị</h2>
            <Text className='col-50 mb10' label='Về tiền (đ):' value={this.props.tienDaThuTrongQuaTrinhThanhTra} />
            <Text className='col-50 mb10' label='Về đất (m2):' value={this.props.datDaThuTrongQuaTrinhThanhTra} />
          </div>
        </div>

        {/* <ShowIf condition={this.props.linhVucThanhTra === 'DAT_DAI'}>
          <div>
            <div className='col-100 pb15'><div className='line-border'></div></div>
            <h2 className='title-14 col-100 mb10'>1.2. Kiến nghị xử lý đất</h2>

            <Text className='col-25 mb10' label='Đất lấn chiếm (m2):' value={this.props.datLanChiemKienNghiXuLyVeDat} />
            <Text className='col-25 mb10' label='Giao, cấp đất sai đối tượng QĐ (m2):' value={this.props.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat} />
            <Text className='col-25 mb10' label='Cấp, bán đất trái thẩm quyền (m2):' value={this.props.capBanDatTraiThamQuyenKienNghiXuLyVeDat} />
            <Text className='col-25 mb10' label='Cấp GCNQSD đất sai (m2):' value={this.props.capGCNQSDDatSaiKienNghiXuLyVeDat} />
            <Text className='col-25 mb10' label='CN, cho thuê không đúng QĐ (m2):' value={this.props.cNChoThueKhongDungQDKienNghiXuLyVeDat} />
            <Text className='col-25 mb10' label='SD đất không đúng MĐ, sai QĐ (m2):' value={this.props.sDDatKhongDungMDKienNghiXuLyVeDat} />
            <Text className='col-25 mb10' label='Bỏ hoang hóa (m2):' value={this.props.boHoanHoaKienNghiXuLyVeDat} />
            <Text className='col-25 mb10' label='Sai phạm khác (m2):' value={this.props.saiPhamKhacKienNghiXuLyVeDat} />

          </div>
        </ShowIf> */}

        <div className='col-100 pb15'><div className='line-border'></div></div>

        <div className='col-100 no-gutter'>
          <h2 className='title-12 col-100 mb15'>1.2 Kiến nghị xử lý khác về kinh tế</h2>
          <Text className='col-25 mb10' label='Về tiền (đ):' value={this.props.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe} />
          <Text className='col-25 mb10' label='Về đất (m2):' value={this.props.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe} />
        </div>
        <div className='col-100 pb15'><div className='line-border'></div></div>

        <div className='col-100 no-gutter'>
          <h2 className='title-12 col-100 mb10'>1.3. Kiến nghị xử lý về hành chính</h2>
          <Text className='col-100 mb10' label='Tổ chức có sai phạm:' value={this.props.toChucCoSaiPham} />
          <Text className='col-25 mb10' label='Bằng tiền (đ):' value={this.props.kienNghiXuLyHanhChinhToChucBangTien} />
          <Text className='col-25 mb10' label='Bằng hình thức khác:' value={this.props.hinhThucKienNghiToChuc} />
          <Text className='col-100 mb10' label='Cá nhân có sai phạm:' value={this.props.caNhanCoSaiPham} />
          <Text className='col-25 mb10' label='Bằng tiền (đ):' value={this.props.kienNghiXuLyHanhChinhCaNhanBangTien} />
          <Text className='col-25 mb10' label='Bằng hình thức khác:' value={this.props.hinhThucKienNghiCaNhan} />
        </div>
        <div className='col-100 pb15'><div className='line-border'></div></div>

        <ShowIf condition={this.props.chucNangCuocThanhTra != 'CHUYEN_NGANH'}>
          <div className='col-100 no-gutter'>
            <h2 className='title-12 col-100 mb10'>{this.props.linhVucThanhTra === 'DAT_DAI' ? '1.5. Kiến nghị chuyển cơ quan điều tra' : '1.4. Kiến nghị chuyển cơ quan điều tra'}</h2>
            <Text className='col-25 mb10' label='Số vụ việc:' value={this.props.soVuViecKienNghiChuyenCoQuanDieuTra} />
            <ShowIf condition={this.props.chuyenCoQuanDieuTra === true}>
              <div className='col-100 no-gutter'>
                <h2 className='title-attach col-100 mb10'>Chuyển cơ quan điều tra</h2>
                <div className='col-100 no-gutter'>
                  <Text className='col-25 mb10' label='Số quyết định:' value={this.props.soQuyetDinhChuyenCoQuanDieuTra} />
                  <Text className='col-25 mb10' label='Người ra quyết định:' value={this.props.nguoiRaQuyetDinhChuyenCoQuanDieuTra} />
                </div>
                <div className='col-100 no-gutter'>
                  <Text className='col-50 mb10' label='Tên cơ quan:' value={this.props.coQuanDieuTraThanhTraInfo ? this.props.coQuanDieuTraThanhTraInfo.text : ''} />
                  <ShowIf condition={this.props.coQuanDieuTraThanhTra === 'KHAC'}>
                    <Text className='col-25 mb10' label='Cơ quan điều tra khác:' value={this.props.coQuanDieuTraKhac} />
                  </ShowIf>
                  <Text className='col-25 mb10' label='Số vụ:' value={this.props.soVuChuyenCoQuanDieuTra} />
                </div>
              </div>
            </ShowIf>
          </div>

          <div className='col-100 pb15'><div className='line-border'></div></div>
        </ShowIf>
        <div className='col-100 no-gutter'>
            <h2 className='title-12 col-100 mb10'>{this.props.linhVucThanhTra === 'DAT_DAI' ? '1.6. Kiến nghị hoàn thiện cơ chế chính sách' : '1.5. Kiến nghị hoàn thiện cơ chế chính sách'}</h2>
            <Text className='col-30 mb10' label='Số kiến nghị hoàn thiện cơ chế chính sách:' value={this.props.soHoanThienCoCheChinhSach} />
          </div>

          <div className='col-100 pb15'><div className='line-border'></div></div>
        <div className='col-100 no-gutter'>
          <h2 className='title-12 col-100 mb10'>{this.props.chucNangCuocThanhTra != 'CHUYEN_NGANH' ? (this.props.linhVucThanhTra === 'DAT_DAI' ? '1.7. Kiến nghị xử lý khác' : '1.6. Kiến nghị xử lý khác') : '1.5. Kiến nghị xử lý khác'}</h2>
          <Text className='col-25 mb10' label='Kiến nghị tiền (đ):' value={this.props.tienKienNghiXuLyKhac} />
          <ShowIf condition={this.props.chucNangCuocThanhTra !== 'CHUYEN_NGANH'}>
            <Text className='col-25 mb10' label='Kiến nghị đất (m2):' value={this.props.datKienNghiXuLyKhac} />
            <TextMessage className='col-100' label='Nội dung kiến nghị khác:' value={this.props.noiDungKienNghiXuLyKhac} />
          </ShowIf>
        </div>
      </div>
    );
  }
}

export default NoiDungKienNghiDoiTuongThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/NoiDungKienNghiDoiTuongThanhTra.jsx